module.exports = __webpack_public_path__ + "static/media/search.a450ec36.svg";